import {IconType} from 'components/Icon/types';
import BaseNotification, {NotificationType} from 'components/Notification';
import {FC} from 'react';
import {t} from 'ttag';

export type MessageKind =
    | 'code_not_found'
    | 'invalid_code_referenced'
    | 'invalid_token'
    | 'unknown_error';

export const allMessageKinds: MessageKind[] = [
    'invalid_code_referenced',
    'unknown_error',
    'code_not_found',
];

export const messageKey: Record<MessageKind, string> = {
    code_not_found: 'code_not_found',
    invalid_code_referenced: 'invalid_code_referenced',
    invalid_token: 'invalid_token',
    unknown_error: 'unknown_error',
};

//const infoType: [NotificationType, IconType] = ['system', 'info'];
const alertType: [NotificationType, IconType] = ['alert', 'warning'];
const dangerType: [NotificationType, IconType] = ['danger', 'danger'];

export const messageType: Record<MessageKind, [NotificationType, IconType]> = {
    code_not_found: dangerType,
    invalid_code_referenced: alertType,
    invalid_token: dangerType,
    unknown_error: alertType,
};

interface Props {
    className?: string;
    kind?: MessageKind;
}

const Notification: FC<Props> = ({className, kind}) => {
    if (!kind || !messageKey[kind]) return null;

    const [type, icon] = messageType[kind];

    const notification = (() => {
        return {
            code_not_found: t`Please confirm you have input your registration code correctly. If your code does not work, please contact the requesting organization.`,
            invalid_code_referenced: t`Please confirm you have input your registration code correctly. If your code does not work, please contact the organization that is requesting your email address.`,
            invalid_token: t`The verification link you used is expired or otherwise invalid. Please request another link by submitting your email address again.`,
            unknown_error: t`An error has occurred. Please try again later. If the problem persists, please contact the requesting organization.`,
        }[messageKey[kind]];
    })();

    return (
        <BaseNotification className={className} icon={icon} type={type}>
            {notification}
        </BaseNotification>
    );
};

export default Notification;
